import { render, staticRenderFns } from "./ContentTypeEdit.vue?vue&type=template&id=2cc6b938&scoped=true&"
import script from "./ContentTypeEdit.vue?vue&type=script&lang=js&"
export * from "./ContentTypeEdit.vue?vue&type=script&lang=js&"
import style0 from "./ContentTypeEdit.vue?vue&type=style&index=0&id=2cc6b938&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc6b938",
  null
  
)

export default component.exports